export default __webpack_public_path__ + "static/media/arquivo-icon.bf983653.svg";